// extracted by mini-css-extract-plugin
export default {"image":"image__ANsQJ","fadeIn":"fadeIn__vtjxO","fadeInAnimation":"fadeInAnimation__PiI3J","heading":"heading__usbm7"};